module.exports = __webpack_public_path__ + "img/ActualPriceIcon.58cfe5ec.svg";